import React, { Component } from "react";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import { toast } from "../../../utils/helpers";

export default class DescuentosForm extends Component {
    state = {
        saving: false
    };
    createDescuento = async event => {
        event.preventDefault();

        this.setState({
            saving: true
        });

        const { empleadoId } = this.props;
        const token = auth.getToken();
        const data = new FormData(event.target);

        const url = `empleados/${empleadoId}/descuentos`;

        const res = await fetch(apiUrl(url), {
            method: "post",
            body: data,
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token
            }
        });

        const response = await res.json();

        if (response.success) {
            this.props.getDescuentos();
            document.getElementById("descuentosform").reset();
            this.props.toggle();
            toast("Descuento creado.");
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }

        this.setState({
            saving: false
        });
    };
    render() {
        return (
            <form
                id='descuentosform'
                method='post'
                onSubmit={this.createDescuento}>
                <input type='hidden' name='_method' value='post' />
                <div className='popup__header'>Crear Descuento Fijo</div>
                <div className='popup__body'>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Nombre:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='text'
                                name='nombre'
                                className='text-input form-control'
                            />
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Monto:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <input
                                type='number'
                                name='monto'
                                step='0.01'
                                className='text-input form-control'
                            />
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className='col col-md-4'>
                            <label className='label form-control-label'>
                                Descripción:
                            </label>
                        </div>
                        <div className='col col-md-8'>
                            <textarea
                                type='text'
                                name='descripcion'
                                rows='6'
                                className='text-input form-control'
                            />
                        </div>
                    </div>
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={this.props.toggle}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    {this.state.saving ? (
                        <Loader type='small' />
                    ) : (
                        <button type='submit' className='btn btn-primary'>
                            Crear
                        </button>
                    )}
                </div>
            </form>
        );
    }
}
